<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row justify-content-start">
      <div class="col-xl-3 col-lg-4 col-12">
        <div class="row justify-content-center">
          <div class="col-auto">
            <el-form-item
              :label="L10n('photo')"
              prop="thumbnailPath"
              data-filed="true"
              class="material-style">
              <image-uploader
                style="width: 16rem"
                :model.sync="form.thumbnailPath"
                folder="Users"
                :rounded="true"
                :label="L10n('change-photo')"/>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-xl-9 col-lg-8 col-12">
        <div class="row">
          <div class="col-lg-auto col-md-6 col-12">
            <el-form-item
              :label="L10n('firstName')"
              prop="firstName"
              :rules="getValidationRule('required,minLength')"
              class="material-style">
              <el-input
                ref="firstField"
                :value="form.firstName"
                @input="form.firstName = valueTrimLeft($event)"
                @change="updateModelItem('firstName', { required: true})"
              />
            </el-form-item>
          </div>
          <div class="col-lg-auto col-md-6 col-12">
            <el-form-item
              :label="L10n('lastName')"
              prop="lastName"
              :rules="getValidationRule('required,minLength')"
              class="material-style">
              <el-input
                :value="form.lastName"
                @input="form.lastName = valueTrimLeft($event)"
                @change="updateModelItem('lastName', { required: true})"
              />
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-auto col-md-6 col-12">
            <el-form-item
              :label="L10n('email')"
              prop="email"
              :rules="getValidationRule('required,email')"
              class="material-style">
              <el-input
                type="email"
                :disabled="hasCreateNew"
                :value="form.email"
                @input="form.email = valueTrimLeft($event)"
                @change="updateModelItem('email', { required: true})"
              />
            </el-form-item>
          </div>
          <div class="col-lg-auto col-md-6 col-12">
            <el-form-item
              :label="L10n('role')"
              prop="roleID"
              :rules="getValidationRule('requiredSelect')"
              class="material-style">
              <select-response
                :model.sync="form.roleID"
                @update:model="updateModelItem('roleID', { required: true})"
                :data="dataSourceRoles.records"
                :isLoading="dataSourceRoles.isLoading"/>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-auto col-md-6 col-12">
            <el-form-item
              :label="L10n('user-path')"
              prop="userPath"
              class="material-style">
              <el-input
                :value="form.userPath"
                @input="form.userPath = valueTrimLeft($event)"
                @change="updateModelItem('userPath')"/>
            </el-form-item>
          </div>
          <div class="col-lg-auto col-md-6 col-12">
            <el-form-item
              :label="L10n('employee')"
              prop="employeeID"
              :rules="getValidationRule('requiredSelect')"
              class="material-style">
              <select-response
                :model.sync="form.employeeID"
                @update:model="updateModelItem('employeeID', { required: true})"
                :data="dataSourceEmployee.records"
                :isLoading="dataSourceEmployee.isLoading"
              />
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-auto col-12">
            <el-form-item
              prop="isActive"
              class="material-style">
              <el-checkbox
                v-model="form.isActive"
                @change="updateModelItem('isActive')">
                {{L10n('is-active')}}
              </el-checkbox>
            </el-form-item>
          </div>
        </div>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormUsers',
  props: {
    hasCreateNew: { type: Boolean }
  },
  mixins: [Form],
  computed: {
    dataSourceRoles () {
      return this.API('Roles/GetAllDynamic?select=id,title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    }
  }
}
</script>
